import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import UserContext from "../utils/context/UserContext";
import * as storageServices from "../utils/services/storageServices";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { user } = useContext(UserContext);
  let isBoarded = user?.team?.isBoarded;
  let isAdmin = user?.members?.peerfiveAdmin;
  // user?.members?.raw_data?.is_admin ||
  // user?.members?.peerfiveAdmin ||
  // user?.members?.raw_data?.is_owner;

  return (
    // Show the component only when the user is logged in
    // Otherwise, redirect the user to /signin page
    <Route
      {...rest}
      render={(props) =>
        storageServices.get(storageServices.TOKEN) ? (
          !isBoarded && isAdmin ? (
            <Redirect to="/onboarding" />
          ) : (
            <Component {...props} />
          )
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

export default PrivateRoute;
